import React, { useState } from 'react';
import {
    Box,
    Button,
    Select,
    TextField,
    MenuItem,
    FormControl,
    InputLabel,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from '@mui/material';
import PropTypes from 'prop-types';
import ApiHelper from 'utils/apiHelper';
import { toast } from 'react-toastify';
import { API_URL } from '../../../utils/constants';
import { validateAlphaPlus, validateAlphanumeric } from '../../../utils/commonHelpers';

const AddDialog = ({ groupsData, onClose, onCloseCancel, inputFields }) => {
    const [groupName, setGroupName] = useState('');
    const [description, setDescription] = useState('');
    const [parentId, setParentId] = useState(null);
    // const [isParent, setIsParent] = useState(false);

    const handleChangeParentId = (e) => {
        setParentId(Number(e.target.value));
    };

    const handleChangeName = (e) => {
        if (e.target.value.length > inputFields['name']) {
            toast.warning('This field must be ' + inputFields['name'] + ' characters or less.');
        } else {
            setGroupName(e.target.value);
        }
    };

    const handleChangeDesc = (e) => {
        if (e.target.value.length > inputFields['desc']) {
            toast.warning('This field must be ' + inputFields['desc'] + ' characters or less.');
        } else {
            setDescription(e.target.value);
        }
    };

    const handleSubmit = () => {
        if (!validateAlphanumeric(groupName)) {
            toast.info('The group name must be alphanumeric');
            return;
        }
        if (!validateAlphaPlus(description)) {
            toast.info('The description must be alphanumeric');
            return;
        }
        ApiHelper.post(API_URL.MANAGEMENT_GROUPS, {
            group_name: groupName,
            description: description,
            // is_parent: data.isParent,
            parent_id: parentId
        })
            .then((res) => {
                if (res.status === 204) {
                    toast.error('Failed! The group name already exists in this parent group');
                } else if (res.status === 205) {
                    toast.error('Failed! The group name is the same as the parent group name');
                } else {
                    toast.success('New group was successfully added.');
                    onClose();
                }
            })
            .catch((err) => {
                toast.error(`Failed! ${err.response.data.message}`);
            });
    };

    return (
        <Dialog open={true} onClose={onCloseCancel}>
            <DialogTitle sx={{ fontSize: '16px' }}>Add New Group</DialogTitle>
            <DialogContent sx={{ minWidth: '500px' }}>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <TextField sx={{ width: '100%' }} label="Group Name" value={groupName} onChange={(e) => handleChangeName(e)} />
                </Box>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <TextField
                        sx={{ width: '100%' }}
                        label="Description"
                        value={description}
                        inputProps={{
                            maxLength: inputFields['desc']
                        }}
                        onChange={(e) => handleChangeDesc(e)}
                    />
                </Box>
                <Box>
                    {/*<FormControlLabel*/}
                    {/*    control={<Checkbox checked={isParent} onChange={handleChangeIsParent} color="primary" />}*/}
                    {/*    label="Is Parent"*/}
                    {/*/>*/}
                    {/*{!isParent &&*/}
                    {/*    (props.tree.length === 0 ? (*/}
                    {/*        <Typography>It should be a parent</Typography>*/}
                    {/*    ) : (*/}
                    <FormControl sx={{ width: '100%', mt: 2 }}>
                        <InputLabel>Parent Group</InputLabel>
                        <Select label="Parent Group" onChange={handleChangeParentId} value={parentId}>
                            {/* <MenuItem value={0}>(root)</MenuItem> */}
                            {groupsData.map((node) => (
                                <MenuItem key={node.id} value={node.id}>
                                    {node.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    {/*))}*/}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCloseCancel}>Cancel</Button>
                <Button disabled={groupName === '' || parentId === null} onClick={handleSubmit}>
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    );
};

AddDialog.propTypes = {
    groupsData: PropTypes.array,
    onClose: PropTypes.func,
    onCloseCancel: PropTypes.func,
    inputFields: PropTypes.object
};

export default AddDialog;
